import { render, staticRenderFns } from "./SignatureMoveable.vue?vue&type=template&id=6a974604&"
import script from "./SignatureMoveable.vue?vue&type=script&lang=js&"
export * from "./SignatureMoveable.vue?vue&type=script&lang=js&"
import style0 from "./SignatureMoveable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports